import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { catchError, throwError } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	constructor(private authService: AuthenticationService) {}

	intercept(req: HttpRequest<unknown>, next: HttpHandler) {
		const authToken = this.authService.token;
		const authRequest = req.clone({
			setHeaders: {
				Authorization: 'Bearer ' + authToken,
			},
		});
		return next.handle(authRequest).pipe(
			catchError((error: HttpErrorResponse) => {
				if (error.status === 401) {
					this.authService.logout();
				}
				return throwError(() => error);
			}),
		);
	}
}
